export default __webpack_public_path__ + "static/media/qualificacao.8d16e084.webp";